module.exports = __webpack_public_path__ + "img/engine-icon.4c39907d.png";